import { createContext } from "react"
export const STRIPE_PUBLIC_KEY = 'pk_test_51LrpNcDkAAw4Z0zyKkds2Obi6BUkAu0CY5Rzo99E7riHtHzft2jENgen0dIsJcf0DW46TR0A8wsw24KAy321szBQ00aqZmOzkh'
export const BASEURL = 'https://us-central1-qr-scanner-469c4.cloudfunctions.net/qrapp'
// export const BASEURL = 'http://localhost:2000'
export const UserContext = createContext(null)

